import {
  MODULE_KEY_BY_PERMISSION_GROUP,
  MODULE_KEY_BY_PERMISSION_ID,
} from '../config/moduleGating.config';
import { getAllPermissionKeysFromTree } from './cascadeHelpers';

function filterPermissionChildren(children, isModuleEnabled) {
  if (!Array.isArray(children)) return children;
  return children
    .filter((child) => {
      const moduleKey = MODULE_KEY_BY_PERMISSION_ID[child.id];
      return !moduleKey || isModuleEnabled(moduleKey);
    })
    .map((child) =>
      child.children
        ? { ...child, children: filterPermissionChildren(child.children, isModuleEnabled) }
        : child,
    );
}

export function filterPermissionTree(fullPermissions, isModuleEnabled) {
  return fullPermissions
    .filter((section) => {
      const moduleKey = MODULE_KEY_BY_PERMISSION_GROUP[section.key];
      return !moduleKey || isModuleEnabled(moduleKey);
    })
    .map((section) =>
      section.children
        ? { ...section, children: filterPermissionChildren(section.children, isModuleEnabled) }
        : section,
    );
}

export function getAvailablePermissionKeySet(filteredPermissions) {
  return getAllPermissionKeysFromTree(filteredPermissions);
}

export function getHiddenPermissionKeySet(fullPermissions, filteredPermissions) {
  const fullKeys = getAllPermissionKeysFromTree(fullPermissions);
  const visibleKeys = getAllPermissionKeysFromTree(filteredPermissions);
  const hidden = new Set();
  fullKeys.forEach((key) => {
    if (!visibleKeys.has(key)) hidden.add(key);
  });
  return hidden;
}
